import React, { useEffect, useRef, useState } from 'react';
import axios from "axios";


const LegendItemForm = ({ item }) => {
  const { ProductSuffix, SignType, ProdOptionId, URL } = item;
  const handleAddToCart = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const quantity = event.target.querySelector(`[name="Quantity"]`).value;
    const productOptionId = event.target.querySelector(`[name="ProductOptionId"]`).value;
   console.log("Quantity", quantity,"ProductOptionId", productOptionId)
    formData.append("Quantity", quantity);
    formData.append("ProductOptionId", productOptionId);

    axios
      .post("/cart/AddToCartLegend", formData)
      .then((response) => {
        showLegendedAddToCartData("#addToCartResult", response.data);
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
        showLegendedAddToCartData("#addToCartResult", {
          success: false,
          message: "Error adding to cart.",
        });
      });
  };


  return (

      <form
        id={`legendedProductAddToCart-${ProductSuffix}${SignType}`}
        className="legendedProductAddToCart"
        onSubmit={handleAddToCart}
      >
        <div className="form-group row">
          <div className="col-xs-5 col-sm-4 responsive-tiny">
            <label htmlFor={`Quantity${ProductSuffix}${SignType}`} className="qtyLabel">
              Quantity:
            </label>
            <input
              className="form-control"
              id={`Quantity${ProductSuffix}${SignType}`}
              name="Quantity"
              min="1"
              type="number"
              defaultValue="1"
              required
              aria-label="Quantity"
            />
          </div>
          <div className="col-xs-7 col-sm-8 responsive-tiny">
            <button type="submit" className="btn btn-primary btn add-to-cart">
              Add to <br className="br-visible-tiny" />Cart
            </button>
          </div>
          <div className="col-xs-12 learn-more responsive-tiny">
            <a href={URL}>Learn More...</a>
          </div>
          <input type="hidden" name="ProductOptionId" defaultValue={ProdOptionId} />
        </div>
      </form>

   
  );
};

export default LegendItemForm;
